import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { PlessViewHelperSub } from "src/app/commons/kymw00/pless-view-helper-sub";
import { KYMW9004InputModel } from "./vo/kymw9004-input.model";
import { KYMW9004Model } from "./kymw9004.model";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { KYMW00Model } from "src/app/commons/kymw00/kymw00.model";
import { GetFunctionListService } from "./api-services/get-function-list.service";
import { GetAuthoritySetDetailService } from "./api-services/get-authority-set-detail.service";
import { RegistAuthoritySetService } from "./api-services/regist-authority-set.service";
import { UpdateAuthoritySetService } from "./api-services/update-authority-set.service";
import { CheckboxLabelComponent } from "src/app/commons/kymw02/checkbox-label/checkbox-label.component";
import { PlessViewUtilsSub } from "src/app/commons/kymw00/pless-view-utils-sub.service";
import { PlessAlert } from "src/app/shared/pless-alert/pless-alert.component";
import { AuthoritySetInformationDetailModel } from "./vo/authority-set-infomation-detail.model";
import { NotNullTextInputComponent } from "src/app/commons/kymw02/not-null-text-input/not-null-text-input.component";
import { FlexGrid } from "@grapecity/wijmo.grid";
import { EventArgs } from "@grapecity/wijmo";

/**
 * 権限セット情報詳細画面を管理するクラス
 *
 * @export
 * @class KYMW9001Component
 * @extends {PlessViewHelperSub}
 * @implements {OnInit}
 */
@Component({
  selector: 'app-kymw9004',
  templateUrl: 'kymw9004.component.html',
  styleUrls: ['kymw9004.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW9004Component extends PlessViewHelperSub implements OnInit {

  kymw9004Model: KYMW9004Model = new KYMW9004Model();
  setKYMW9004Parameter: Function;

  /** 親画面からの受渡し情報 */
  private inputVO: KYMW9004InputModel = null;

  /** 登録・更新用の情報 */
  private authoritySetInfoDetailModel: AuthoritySetInformationDetailModel = null;

  @ViewChild('chk_AdminDiv', { static: true }) chk_AdminDiv: CheckboxLabelComponent;
  // セット名の入力文字が多いためtextareaに変更する可能性あり。決まり次第対応予定
  @ViewChild('txt_authoritySetName', { static: true }) txt_authoritySetName: NotNullTextInputComponent;
  @ViewChild('dgt_FuncAuthorityList', { static: true }) dgt_FuncAuthorityList: FlexGrid;

  /**
     * Creates an instance of KYMW9000Component.
     * @param {PlessDialogServiceSub} dialogService
     * @param {KYMW00Model} kymw00Model
     * @param {ElementRef} elementRef
     * @memberof KYMW9004Component
     */
    constructor(
      public dialogService: PlessDialogServiceSub,
      private kymw00Model: KYMW00Model,
      private elementRef: ElementRef,
      private getFunctionListService: GetFunctionListService,
      private getAuthoritySetDetailService: GetAuthoritySetDetailService,
      private registAuthoritySetService: RegistAuthoritySetService,
      private updateAuthoritySetService: UpdateAuthoritySetService,
    ) {
      super(kymw00Model);
    }

  /**
   * 初期処理
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW9004';
    this.kymw9004Model.kymw9004Component = this;

    this.txt_authoritySetName.setFocus();

    // パラメーターが渡されている場合(更新の場合)
    if (this.inputVO.authoritySetId) {
      this.getFunctionListService.execute(this.kymw9004Model, ()=>{
        this.getAuthoritySetDetailService.execute(this.kymw9004Model, this.inputVO);
      })
    } else {
      // 新規登録の場合
      this.getFunctionListService.execute(this.kymw9004Model, (data)=> {
        if ( PlessViewUtilsSub.isEmptyArray(data.FuncInfoList)) {
          this.dialogService.openAlert('システムエラーが発生しました', 'S');
        }
      });
    }

    // グリッドの初期選択行はなしとする
    this.dgt_FuncAuthorityList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dgt_FuncAuthorityList.select(-1, -1);
    });
  }

  /**
   * 親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW9001Component
   */
  public setInterfaceParam(param: any): void {
    this.inputVO = <KYMW9004InputModel>param;
    this.kymw9004Model.authoritySetId = this.inputVO.authoritySetId;
  }

  /**
   * 設定ボタン押下時
   * 
   */
  public eventSet_CLICKHandler() {
    // 必須入力値チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw9004Model.authoritySetName)) {
      this.dialogService.openAlertGetMessage('W0001', ['セット名']);
      return false;
    }
      
    this.dialogService.openAlertGetMessage('Q0193', [], (closeEvent: any) => {
      if (closeEvent === PlessAlert.Yes) {
        const reqVO = this.createAuthoritySetInformationDetaiVO();
        // 新規登録の場合
        if(PlessViewUtilsSub.isEmpty(this.kymw9004Model.authoritySetId)) {
          this.registAuthoritySetService.execute(this.kymw9004Model, reqVO, (data) => {
            this.kymw9004Model.authoritySetId = data.AuthoritySetId;
          });
        } else {
          // 更新の場合
          this.updateAuthoritySetService.execute(this.kymw9004Model, reqVO);
        }
      }
    })
  }

  /**
   * 新規登録・更新のVO作成
   * 
   */
  public createAuthoritySetInformationDetaiVO() {
    const reqVO: AuthoritySetInformationDetailModel = new AuthoritySetInformationDetailModel();
    reqVO.authoritySetName = this.kymw9004Model.authoritySetName;
    // 管理者権限有無チェック
    if ( this.kymw9004Model.check_AdminDiv ) {
      reqVO.adminDiv = "1";
    } else {
      reqVO.adminDiv = "0";
    }
    reqVO.authoritySetExplanation = this.kymw9004Model.authoritySetExplanation;
    reqVO.authorityStatus = this.kymw9004Model.authorityStatus;
    reqVO.funcAuthorityList = this.kymw9004Model.funcAuthorityList;

    // 更新の場合
    if ( this.inputVO.authoritySetId || this.kymw9004Model.authoritySetId ) {
      reqVO.authoritySetId = this.kymw9004Model.authoritySetId;
    }

    return reqVO;
  }
}